import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ViewChild, ViewChildren, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { PlatformApiService, PlanSearchCriteria } from '../../services/platform-api.service';
import { Brand, Account } from '../../models/AccountModel';
import { GridSpinnerComponent } from '../../shared/grid-spinner.component';
import { SessionService } from 'src/app/services/session.service';


@Component({
  selector: 'app-account-brand',
  templateUrl: './account-brand.component.html',
  styleUrls: ['./account-brand.component.scss']
})
export class AccountBrandComponent implements OnInit {
  _account: Account;
  _brand: Brand = new Brand();
  brands: Brand[];
  selectedColor = 'baseColor';
  selectedName = 'Base Color';
  toggle = true;
  showPatterns = false;
  showColors = false;

  brandFormGroup = new FormGroup({
    baseColor: new FormControl('', [Validators.required]),
    highlightColor: new FormControl('', [Validators.required]),
    textBackgroundColor: new FormControl('', [Validators.required]),
    documentTitlePage: new FormControl('', [Validators.required]),
    documentPageHeader: new FormControl('', [Validators.required])
  });

  @ViewChild('spinner', { static: true }) spinner: GridSpinnerComponent;
  // @ViewChild(MatTabGroup) tabs: MatTabGroup;

  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  @Input() set account(value: Account) {
    this.spinner.showSpinner('Loading brand...');
    this._account = value;
    // This will get the brand associated with the account or the default brand, currently 'Sienna'
    this._platformApi.getAccountBrand(this._account.id, undefined).subscribe(
      resp => {
        this.brand = resp;
        if (this._brand.name === 'sienna' || this._brand.id === 1) {
          // This is a clone of the default brand, so change name and id from default
          this._brand.name = this._account.name;
          this._brand.id = null;
        }
        this.spinner.hideSpinner();
      }
    );
  }

  @Input() set brandId(id: number) {
    this.spinner.showSpinner('Loading brand...');
    this._platformApi.getBrand(id).subscribe(brand => {
      this.brand = brand;
      this.spinner.hideSpinner();
    })
  }

  set brand(value: Brand) {
    console.log(value);
    if (value && !value.name) {
      this.loadDefaultBrand();
      return;
    }
    this._brand = value;
    this.selectedColor = 'baseColor';
    // this.showColors = true;
    this.brandFormGroup.reset();
    this.brandFormGroup.controls.baseColor.setValue(this._brand.baseColor);
    this.brandFormGroup.controls.highlightColor.setValue(this._brand.highlightColor);
    this.brandFormGroup.controls.textBackgroundColor.setValue(this._brand.textBackgroundColor);
    this.brandFormGroup.controls.documentTitlePage.setValue(this._brand.documentTitlePage);
    this.brandFormGroup.controls.documentPageHeader.setValue(this._brand.documentPageHeader);
  }

  constructor(private _platformApi: PlatformApiService, private _sessionService: SessionService) { }

  ngOnInit() {
  }

  /*
   * imageChange - Called when an image is selected from the file chooser
  */
  imageChange(name, event) {
    if (name === 'Title') {
      name = 'documentTitlePage';
    } else if (name === 'Content') {
      name = 'documentPageHeader';
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onloadend = (e) => {
        this._brand[name] = reader.result;
        this.brandFormGroup.controls[name].setValue(this._brand[name]);
      };
    }
  }

  /*
   * colorChange - Called when the color picker changes color
  */
  colorChange(evname) {
    this.brandFormGroup.controls[this.selectedColor].setValue(this._brand[this.selectedColor]);
  }

  /*
   *
  */
  loadDefaultBrand(spinnerMessage?: string) {
    if (!spinnerMessage === undefined) {
      this.spinner.showSpinner();
    }
    this._platformApi.getAccountBrand(this._account.id, undefined).subscribe(resp => {
      this._brand = resp;
      this._brand.name = this._account.name;
      this._brand.id = null;
      this.brand = this._brand;
      console.log(this._account, this._sessionService.getCurrentAccount());
      if (this._account.id == this._sessionService.getCurrentAccount().id) {
        this._sessionService.updateWorkingAccount(this._account);
      }
      if (spinnerMessage !== undefined) {
        this.spinner.showMessage(spinnerMessage, 1500);
      } else {
        this.spinner.hideSpinner();
      }
    });
  }

  /*
   * save - Called from save button
  */
  save() {
    this.spinner.showSpinner('Saving brand...');
    const json = Object.assign({}, this._brand, this.brandFormGroup.value);
    // let json = JSON.stringify(this._brand);
    if (this._account) {
      // This saves for brand associated with an msp account
      this._platformApi.saveAccountBrand(this._account.id, this._brand.id, { brand: json }).subscribe(
        resp => {
          if (this._brand.id !== resp.id) {
            // The account is updated by the api call
            this._account.brandingId = resp.id;
          }
          this._brand = resp;
          this.changeState('CREATESUCCESS');
        }
      );
    }
    else {
      // This saves for admin brands
      this._platformApi.saveBrand(this._brand.id, { brand: json }).subscribe(
        resp => {
          this._brand = resp;
          this.changeState('CREATESUCCESS');
        }
      );
    }
  }

  revertToDefault() {
    if (this._account) {
      this.spinner.showSpinner('Reverting to the default brand.');
    } else {
      this.spinner.showSpinner('Deleting the custom brand.');
    }

    const json = Object.assign({}, this._brand, this.brandFormGroup.value);
    // let json = JSON.stringify(this._brand);
    if (this._account) {
      // This saves for brand associated with an msp account
      this._platformApi.deleteAccountBrand(this._account.id, this._brand.id).subscribe(
        resp => {
          this._account.brandingId = undefined;
          this.changeState('REVERTTODEFAULT');
        }
      );
    }
    else {
      // This saves for admin brands
      this._platformApi.deleteBrand(this._brand.id).subscribe(
        resp => {
          this.changeState('REVERTTODEFAULT');
        }
      );
    }
  }

  /*
   * cancel - Called from cancel button
  */
  cancel() {
    this.brandFormGroup.reset();
    this.changeState('EDITCANCEL');
  }

  getRevertButtonText() {
    return (this._account) ? 'Revert to Default' : 'Delete Brand';
  }

  changeState(state: string) {
    switch (state) {
      case 'CREATESUCCESS':
      case 'EDITSUCCESS':
        this.spinner.showMessage('Brand successfully saved!', 1500);
        break;
      case 'REVERTTODEFAULT':
        if (this._account) {
          this.loadDefaultBrand('Custom brand has been removed.');
        }
        break;
      case 'CREATECANCEL':
      case 'EDITCANCEL':
        this.spinner.hideSpinner();
        break;
    }
    this.stateChange.emit({ state });
  }

}
